// theme.js

export const boomPayTheme = {
    primaryColor: "boom",
  
    colors: {
      boom: [
        "#F4EBFF",
        "#E9D8FD",
        "#D6BCFA",
        "#B794F4",
        "#9F7AEA",
        "#8B5CF6",
        "#7C3AED",
        "#6D28D9",
        "#5B21B6",
        "#4C1D95",
      ],
    },
  
    defaultRadius: "md",
  };